<template>
  <vxe-grid
    border
    resizable
    auto-resize
    highlight-hover-row
    size="mini"
    :columns="tableColumns"
    :data="data"
    :row-class-name="rowClassName"
  />
</template>
<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: '字段名',
          field: 'field',
          minWidth: 140,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '原始文件值',
          field: 'origin',
          minWidth: 140,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '更新文件值',
          field: 'current',
          minWidth: 140,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          className: 'current',
        },
      ],
    }
  },
  methods: {
    rowClassName({ row }) {
      const { current } = row
      if (current == undefined || current == null) return
      return 'changed'
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-body--row.changed {
    background-color: #fbe9eb;
    .vxe-body--column.current {
      font-weight: bold;
      color: #000000;
    }
  }
}
</style>
